import { render, staticRenderFns } from "./Integrator.vue?vue&type=template&id=8dc6e3b2&scoped=true"
import script from "./Integrator.vue?vue&type=script&lang=js"
export * from "./Integrator.vue?vue&type=script&lang=js"
import style0 from "./Integrator.vue?vue&type=style&index=0&id=8dc6e3b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc6e3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc6e3b2')) {
      api.createRecord('8dc6e3b2', component.options)
    } else {
      api.reload('8dc6e3b2', component.options)
    }
    module.hot.accept("./Integrator.vue?vue&type=template&id=8dc6e3b2&scoped=true", function () {
      api.rerender('8dc6e3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Integrator.vue"
export default component.exports